<template>
  <v-bottom-navigation
    color="white"
    horizontal
    app
    background-color="primary"
  >
    <v-btn 
      :href="url"
      download
    >
      <span>Download Price List</span>
      <v-icon>mdi-cloud-download</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
    export default {
        data () {
            return {
              url: 'https://api.mrpoolal.com/storage/docs/pricelist.doc'
            }
        },
        methods: {

        }
    }
</script>

<style lang="sass">
.v-bottom-navigation 
  button 
      span
          color: #fff

  .v-btn
    >.v-btn__content
      color: #fff
      
      .v-icon
        color: #fff
</style>